<template>
  <div :class="{ 'brought-in' : currentNrOfVarietiesToBeCompared > 1 }">
    <p
      :class="{ 'show-hint': showHint }"
      v-text="translate('lblComparisonLimitReached', { max: maxNrOfVarietiesToBeCompared })"
    ></p>
    <a :href="link"><span v-text="currentNrOfVarietiesToBeCompared"></span><span v-text="openComparisonLabel"></span></a>
  </div>
</template>

<script>
export default {
  name: 'CompareButton',
  data: () => ({
    showHint: false,
  }),
  props: {
    maxNrOfVarietiesToBeCompared: {
      type: Number,
      required: false,
    },
    crop: {
      type: String,
      required: true,
    },
    hintVisibleDuration: {
      type: Number,
      default: 3,
    },
    idsToBeCompared: {
      type: Array,
      default: () => [],
    },
    comparisonView: String,
    openComparisonLabel: String,
  },
  computed: {
    link() {
      const urlSearchParams = new URLSearchParams();
      urlSearchParams.set('comparison-ids', JSON.stringify(this.idsToBeCompared));
      urlSearchParams.set('crop', JSON.stringify(this.crop));
      return `${this.comparisonView}?${urlSearchParams.toString()}`;
    },
    currentNrOfVarietiesToBeCompared() {
      return this.idsToBeCompared.length;
    },
  },
  mounted() {
    document.addEventListener('too-many-varieties-to-compare', () => {
      this.showHint = true;
      setTimeout(() => {
        this.showHint = false;
      }, 1000 * this.hintVisibleDuration);
    });
  },
};
</script>

<style scoped lang="scss">
div {
  position: fixed;
  z-index: 4;
  inset-inline-end: 0;
  bottom: 10vh;
  width: min-content;
  overflow: hidden;
  transition: all .3s ease-in-out;
  transform: translate(100%, 0);
  [dir=rtl] & {
    transform: translate(-100%, 0);
  }

  &.brought-in {
    transform: translate(0, 0);
  }

  p {
    padding: rem(10px);
    background-color: $color-kws-dark-gray-100;
    color: $color-white;
    font-weight: 500;
    margin: 0;
    flex-grow: 1;
    transition: all .5s ease-in-out;
    transform: translate(0, 100%);
    border-top: 1px solid $color-white;
    border-inline-start: 1px solid $color-white;

    &.show-hint {
      transform: translate(0, 0);
    }
  }

  a {
    background-color: $color-kws-dark-gray-100;
    color: $color-white;
    display: flex;
    align-items: center;
    padding: rem(10px) rem(16px);
    border: 1px solid $color-white;
    border-inline-end: 0;
    font-weight: 700;
    text-transform: uppercase;
    position: relative;

    span:first-child {
      background-color: $color-white;
      color: $color-kws-dark-gray-100;
      display: inline-block;
      padding: 4px 8px;
      margin-inline-end: rem(12px);
    }

  }
}
</style>
